<template>
    <v-dialog title="调整顺序" v-if="innerShow" v-model="innerShow" size="md"
              :show-close="true">
        <table class="table table-hover table-bordered">
            <tbody>
            <tr style="cursor: default !important;" v-for="(data, index) in model" :key="index">
                <td>
                    {{data.levelName}}
                </td>
                <td class="row">
                    <div class="col-sm-6" v-if="index !== model.length - 1" style="float: right">
                                    <span class="icon-arrow-down control-icon click-able"
                                          @click="downIncludeItems(index)"></span>
                    </div>
                    <div class="col-sm-6" v-if="index !== 0" style="float: right">
                                    <span class="icon-arrow-up control-icon click-able"
                                          @click="upIncludeItems(index)"></span>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <div class="modal-footer">
            <button class="btn btn-primary" @click="save()">保存</button>
        </div>
    </v-dialog>
</template>
<script>
    export default {
        data () {
            return {
                innerShow: false
            };
        },
        props: {
            model: {
                type: Array,
                required: true
            },
            show: {
                require: true,
                'default': false
            }
        },
        computed:{

        },

        methods: {
            save() {
                this.$emit('saveSort', this.model);
            },
            upIncludeItems: function (index) {
                const temp = Object.assign(this.model[index], {})
                this.$set(this.model, index, Object.assign(this.model[index - 1], {}))
                this.$set(this.model, index - 1, Object.assign(temp, {}))
            },
            downIncludeItems: function (index) {
                const temp = Object.assign(this.model[index], {})
                this.$set(this.model, index, Object.assign(this.model[index + 1], {}))
                this.$set(this.model, index + 1, Object.assign(temp, {}))
            }
        },
        watch: {
            show() {
                this.innerShow = this.show;
            }
        },
        mounted () {
            this.innerShow = this.show;
        }
    }
</script>

<style rel="stylesheet/css" lang="postcss" scoped type="text/postcss">
    .modal-footer {
        text-align: center;
        padding-top: 10px;
    }
    .click-able {
        cursor: pointer;
    }
    .control-icon {
        display: inline-block;
        font-size: 18px;
        width: 20%;
        color: #06c1ae;
    }
</style>



// WEBPACK FOOTER //
// sortDialog.vue?14f56106